import React from 'react'
import emailIcon from 'assets/img/icons/icon_email_v01.png'
import gearIcon from 'assets/img/icons/icon_gears_v01.png'
import villageIcon from 'assets/img/icons/icon_village_v01.png'

const styles = {
  iconBg: {
    marginTop: '20px',
    backgroundSize: '30px'
  },
  emailIcon: {
    background: 'url(' + emailIcon + ') no-repeat'
  },
  gearIcon: {
    background: 'url(' + gearIcon + ') no-repeat'
  },
  villageIcon: {
    background: 'url(' + villageIcon + ') no-repeat'
  }
}

const Sidebar = () => {
  return (
    <div className="island promo-content">
      <h3>This is your window to their world</h3>
      <p>Thank you for supporting World Vision Philippines. You are helping the lives of children
        around the world.</p>
      <div className="row">
        <div className="col-xs-2">
          <div className="icon" style={{ ...styles.emailIcon, ...styles.iconBg }}></div>
        </div>
        <div className="col-xs-10">
          <h3>WRITE TO YOUR SPONSORED CHILD</h3>
          <p>Introduce yourself and share special moments with your sponsored child through
            words and photos.</p>
        </div>

        <div className="col-xs-2">
          <div className="icon" style={{ ...styles.gearIcon, ...styles.iconBg }}></div>
        </div>
        <div className="col-xs-10">
          <h3>Manage Your Profile</h3>
          <p>Update your information and stay up to date with notifications all in a central
            spot.</p>
        </div>

        <div className="col-xs-2">
          <div className="icon" style={{ ...styles.villageIcon, ...styles.iconBg }}></div>
        </div>
        <div className="col-xs-10">
          <h3>Explore Their World</h3>
          <p>Discover their home and learn about their culture with images.</p>
        </div>
      </div>
    </div>
  )
}

export default Sidebar